import { render, staticRenderFns } from "./StocksInventory.vue?vue&type=template&id=54e9d563"
import script from "./StocksInventory.vue?vue&type=script&lang=js"
export * from "./StocksInventory.vue?vue&type=script&lang=js"
import style0 from "./StocksInventory.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./StocksInventory.vue?vue&type=custom&index=0&blockType=i18n&locale=ru&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54e9d563', component.options)
    } else {
      api.reload('54e9d563', component.options)
    }
    module.hot.accept("./StocksInventory.vue?vue&type=template&id=54e9d563", function () {
      api.rerender('54e9d563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "site/src/views/stocks/StocksInventory.vue"
export default component.exports